export enum EtaEmitter {
  DRIVER = 'DRIVER',
  SAP_PGI = 'SAP_PGI',
  SAP_PLANNING_PRELOADED = 'SAP_PLANNING_PRELOADED',
  CMBL_AUTOMATIC_ETA = 'CMBL_AUTOMATIC_ETA',
  EXTERNAL = 'EXTERNAL',
  FOURKITES = 'FOURKITES',
  TMS_BLUEYONDER = 'TMS_BLUEYONDER',
  CARRIER = 'CARRIER',
}
